<template>
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
  
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content report-box  container-fluid">
  
        <div>
          <h1>{{ $store.getters.currentLanguage === 'en' ? 'Processes launched according to responsable' : 'Procesos lanzados según responsable' }}</h1>
        </div>
  
        <div class="row">
          <div class="col-sm-12">
            <div class="legend-container">
              <span @mouseover="highlightCategory('ACTIVO')" @mouseout="resetHighlight" class="legend-item">
                <span class="legend-color" style="background-color: #28a745;"></span> ACTIVO
              </span>
              <span @mouseover="highlightCategory('ELIMINADO')" @mouseout="resetHighlight" class="legend-item">
                <span class="legend-color" style="background-color: #dc3545;"></span> ELIMINADO
              </span>
              <span @mouseover="highlightCategory('FINALIZADO')" @mouseout="resetHighlight" class="legend-item">
                <span class="legend-color" style="background-color: #17a2b8;"></span> FINALIZADO
              </span>
              <span @mouseover="highlightCategory('INACTIVO')" @mouseout="resetHighlight" class="legend-item">
                <span class="legend-color" style="background-color: #ffc107;"></span> INACTIVO
              </span>
            </div>
            <div class="card">
                <div id="chart">
                <apexchart 
                    type="bar" 
                    height="350" 
                    :options="chartOptions" 
                    :series="series"
                />
                </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-12">
            <b-button variant="primary" @click="copiarTabla" class="ms-1">{{ $store.getters.currentLanguage === 'en' ? 'Copy Table' : 'Copiar Tabla' }}</b-button>
            <b-button variant="secondary" @click="imprimirTabla" class="ms-1">{{ $store.getters.currentLanguage === 'en' ? 'Print Table' : 'Imprimir Tabla' }}</b-button>
            <b-button variant="success" @click="descargarExcel" class="ms-1">{{ $store.getters.currentLanguage === 'en' ? 'Download Excel' : 'Descargar Excel' }}</b-button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <div class="showentries">
                  <div class="entries">
                    <span>Buscar: </span>
                    <input
                      type="search"
                      class="form-control form-control-sm ms-2"
                      placeholder=""
                      aria-controls="DataTables_Table_0"
                      v-model = "searched_value"
                      @input="localSearch()"
                    />
                  </div>
                </div>
                <div class="table-responsive">
                  <a-table
                    class="stripped table-hover"
                    :columns="columnsTableJobOffers"
                    :data-source="dataTableFiltJobOffers"
                    id="tabla-ofertas"
                  >
                    <template #bodyCell="{ column, record }">
                      <template v-if="column.key === 'numero'">
                          <div>{{ record.numero }}</div>
                      </template>
                      <template v-if="column.key === 'puesto_de_trabajo'">
                        <div>{{ record.puesto_de_trabajo }}</div>
                      </template>
                      <template v-if="column.key === 'lugar'">
                        <div>{{ record.lugar }}</div>
                      </template>
                      <template v-if="column.key === 'nombre'">
                        <div>{{ record.nombre }}</div>
                      </template>
                      <template v-if="column.key === 'estado'">
                        <div>{{ record.estado }}</div>
                      </template>
                      <template v-else-if="column.key === 'numero'">
                      </template>
                    </template>
                  </a-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  
  <script>

import axiosIns from '@/plugins/axios.js';
import VueApexCharts from 'vue3-apexcharts';
import * as XLSX from 'xlsx'; // Para exportar la tabla a Excel
import { router } from "@/router";

export default {
  components: {
    apexchart: VueApexCharts
  },
  data() {
  return {
    series: [{
      name: 'Ofertas Laborales',
      data: [],  // Inicialmente vacío, lo llenas después de la API call
    }],
    chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: 'top',
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return Math.round(val);
          }
        },
        colors: [ '#28a745','#dc3545','#17a2b8','#ffc107'],
        xaxis: {
          categories: [],  // Inicialmente vacío, se llena con los estados después de la API call
          labels: {
            style: {
              fontSize: '12px',  // Tamaño de la fuente
              fontWeight: 'bold' // Negrita para mayor visibilidad
            }
          }
        },
        legend: {
          position: 'top'
        },
        title: {
          text: 'Ofertas Laborales por Responsable',
          align: 'center',
          style: {
            fontSize: '16px',
            fontWeight: 'bold',
          },
        },
        tooltip: {
          y: {
              formatter: function (val) {
                  return Math.round(val); // Redondea el valor a un número entero
              }
          }
      },
    },
    columnsTableJobOffers: [
        { title: "N°", key: "numero" },
        { title: "Puesto de trabajo", key: "puesto_de_trabajo" },
        { title: "Lugar", key: "lugar" },
        { title: "Responsable", key: "nombre" },
        { title: "Estado", key: "estado" },
      ],
      dataTableJobOffers: [],  // Datos originales
      dataTableFiltJobOffers: [],  // Datos filtrados
      searched_value: "",  // Valor de búsqueda
      entriesToShow: 5,  // Número de registros a mostrar
    }
  },
  beforeRouteEnter(to, from, next){
    if (!localStorage.getItem('userDataAdmin')) {
      router.push('/admin/login');
    }else{
      next()
    }
  },
  mounted() {
    this.ofertasPorResponsableGrafico();
    this.ofertasPorResponsableTabla();
  },
  methods: {
    ofertasPorResponsableGrafico() {
        const yo = this
        const config = {
            method: 'get',
            url: '/talentoagv/offersByResponsableGraph/',
        }

        axiosIns(config)
            .then(response => {
            if (response.data['is_error'] === false) {
                const result = response.data.result;
                const responsables = [...new Set(result.map(item => item.nombre))];  // Responsables únicos
                const estados = [...new Set(result.map(item => item.estado))];

                const seriesData = estados.map(estado => {
                  return {
                    name: estado,
                    data: responsables.map(responsable => {
                      const match = result.find(item => item.nombre === responsable && item.estado === estado);
                      return match ? match.cantidad : 0;  // Si no hay match, el valor es 0
                    })
                  }
                });
                
                // Actualizar los datos del gráfico
                yo.series = seriesData;
                yo.chartOptions.xaxis.categories = responsables;

                yo.$nextTick(() => {
                    yo.chartOptions = { ...yo.chartOptions }; // Para que Vue reactive los cambios
                });

            }
            })
            .catch(error => {
            console.log(error);
            yo.$toastr.error(error, 'Error');
            });
    },

    ofertasPorResponsableTabla() {
      const yo = this
      yo.dataTableJobOffers=[]
      const config = {
        method: 'get',
        url: '/talentoagv/offersByResponsableTable/',  // Ruta de la API
      };

      axiosIns(config)
          .then(function (response) {
            // console.log(response.data['result'])
            if (response.data['is_error'] === false){
                let resultado = response.data['result']
                yo.dataTableJobOffers = resultado
                yo.dataTableFiltJobOffers = resultado
                yo.allData = resultado
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toastr.error(response.data['message'], 'Error')
          })
          .finally(function (){
            
          })
    },
    localSearch() {
      const searched = this.searched_value.toLowerCase();
      this.dataTableFiltJobOffers = this.dataTableJobOffers.filter((offer) =>
       offer.puesto_de_trabajo && offer.puesto_de_trabajo.toLowerCase().includes(searched) ||
       offer.nombre && offer.nombre.toLowerCase().includes(searched) ||
       offer.lugar && offer.lugar.toLowerCase().includes(searched) ||
       offer.estado && offer.estado.toLowerCase().includes(searched) 
        
      );
    },
    copiarTabla() {
        const rows = this.dataTableFiltJobOffers;  // Accedemos a los datos que deseas copiar
      let tableText = '';

      // Creamos la cabecera
      const headers = ["N°", "Puesto de trabajo", "Lugar", "Responsable", "Estado"];
      tableText += headers.join("\t") + "\n";  // Añadimos una tabulación entre cada columna

      // Recorremos las filas para generar el texto
      rows.forEach(row => {
          tableText += `${row.numero}\t${row.puesto_de_trabajo}\t${row.lugar}\t${row.nombre}\t${row.estado}\n`; // Tabulación entre valores
      });

      // Copiamos el texto al portapapeles usando la API de navegador
      navigator.clipboard.writeText(tableText).then(() => {
          this.$toastr.success("¡Tabla copiada al portapapeles!", "Éxito");
      }).catch(err => {
          console.error("Error al copiar la tabla: ", err);
          this.$toastr.error("Error al copiar la tabla.", "Error");
      });
    },
      // Imprimir la tabla
    imprimirTabla() {
        const printContents = document.getElementById('tabla-ofertas').outerHTML;
        const printWindow = window.open('', '', 'height=600,width=800');
        printWindow.document.write('<html><head><title>Reporte de procesos lanzados según responsable</title></head><body>');
        printWindow.document.write(printContents);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
    },

        // Descargar la tabla en Excel
    descargarExcel() {
    // Ordenar los datos por la clave "id"
    const sortedData = [...this.dataTableFiltJobOffers].sort((a, b) => a.numero - b.numero);

    // Crear un nuevo libro de Excel
    const wb = XLSX.utils.book_new();

    // Definir los encabezados de las columnas
    const headers = [
      { header: "N°", key: "numero" },
      { header: "Puesto de trabajo", key: "puesto_de_trabajo" },
      { header: "Lugar", key: "lugar" },
      { header: "Responsable", key: "nombre" },
      { header: "Estado", key: "estado" }
    ];

    // Crear la hoja de Excel con los datos ordenados
    const ws = XLSX.utils.json_to_sheet(sortedData, {
      header: headers.map(h => h.key)  // Usar las claves para los datos
    });

    // Aplicar los nombres de los encabezados y estilos personalizados
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let i = 0; i < headers.length; i++) {
      const cell_ref = XLSX.utils.encode_cell({ r: 0, c: i });
      ws[cell_ref].v = headers[i].header;  // Reemplazar con los nombres personalizados
      ws[cell_ref].s = {
        fill: {
          patternType: "solid",
          fgColor: { rgb: "CCFFCC" }  // Color verde claro en formato RGB
        },
        font: {
          bold: true,
          color: { rgb: "000000" }  // Color de texto negro
        },
        alignment: {
          horizontal: "center",  // Centrar el texto
          vertical: "center"
        }
      };
    }

    // Agregar la hoja al libro
    XLSX.utils.book_append_sheet(wb, ws, 'data');

    // Descargar el archivo Excel
    XLSX.writeFile(wb, 'ofertas_laborales_responsable.xlsx');
    },
    highlightCategory(estado) {
      const seriesIndex = this.series.findIndex(serie => serie.name === estado);
      if (seriesIndex !== -1) {
        // Aquí ajustamos los colores de cada barra
        const newColors = this.chartOptions.colors.map((color, index) => {
          return index === seriesIndex ? color : '#cccccc'; // Resalta el color correspondiente
        });
        
        // Actualizar la configuración de colores
        this.chartOptions.colors = newColors;

        this.$nextTick(() => {
          this.chartOptions = { ...this.chartOptions }; // Forzar la actualización del gráfico
        });
      }
    },
    
    resetHighlight() {
      // Restaurar los colores originales
      this.chartOptions.colors = ['#28a745','#dc3545','#17a2b8','#ffc107']; // Colores originales
      this.$nextTick(() => {
        this.chartOptions = { ...this.chartOptions };
      });
    }
  }
}
</script>

<style>
#chart {
  margin-top: 20px;
}


.legend-container {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.legend-item {
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.legend-color {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}
</style>


  